import axios, { AxiosInstance } from 'axios';
import queries from './graphqlQueries';
import { persistor, store } from '../store';
import {
  setErrorAction as setErrorAnalytics,
  setLogRequestID,
} from '../store/analytic/actions';
import {
  setErrorAction,
  setNetworkErrorAction,
  setWppErrorAction,
} from '../store/error/actions';
import { Config } from '../config';

class ConfigThemeService {
  private instance: AxiosInstance;
  private queries: typeof queries;
  constructor() {
    this.instance = axios.create({
      baseURL: process.env.REACT_APP_API || '/backend/',
      headers: { 'Id-config': Config.ID_CONFIG },
      //baseURL:'http://localhost:3000/'
    });
    this.instance.interceptors.response.use(
      (response) => {
        const logId = response.headers['log-request-id'] as string;
        store.dispatch(
          setLogRequestID(Number.parseInt(logId === '' ? '0' : logId))
        );
        if (response.data.errors) {
          if (response.data.errors[0].message === 'Unauthorized')
            persistor.purge();
          else {
            const analytic = ((store.getState() as unknown) as ApplicationState)
              .analytic;
            store.dispatch(
              setErrorAnalytics.request({
                options: {
                  actionId: analytic.navigation?.id ?? 0,
                  errorMessage: response.data.errors[0].message,
                  srcId: analytic.logRequestID ?? 0,
                },
              })
            );
            response.data.errors[0].message === 'Confirme seu telefone.'
              ? store.dispatch(setWppErrorAction(true))
              : store.dispatch(setErrorAction(true));
          }
        }
        return response;
      },
      (error) => {
        const logId = error.response.headers['log-request-id'] as string;
        store.dispatch(
          setLogRequestID(Number.parseInt(logId === '' ? '0' : logId))
        );

        if (error?.message === 'Network Error') {
          store.dispatch(setNetworkErrorAction());
        }
        if (error && error.response && 401 === error.response.status) {
          persistor.purge();
          return;
        }

        const analytic = ((store.getState() as unknown) as ApplicationState)
          .analytic;
        store.dispatch(
          setErrorAnalytics.request({
            options: {
              actionId: analytic.navigation?.id ?? 0,
              errorMessage: error?.message,
              srcId: analytic.logRequestID ?? 0,
            },
          })
        );
        return Promise.reject(error);
      }
    );
    this.queries = queries;
  }

  loadConfig = async (): Promise<ConfigState> => {
    const result = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.config()
    );
    if (result.data.errors) throw new Error(result.data.errors.join(', '));
    const config = (result.data.data as GQL.IQuery).getSanConfigura;

    return {
      assessoriaPalette: config?.assessoriaPalette || '#3C50E0',
      corEscura: config?.corEscura || '',
      corEscuraSecundaria: config?.corEscuraSecundaria || '',
      corClara: config?.corClara || '',
      corHeader: config?.corHeader || '',
      corFooter: config?.corFooter || '',
      homePageLinkColor: config?.homePageLinkColor || '',
      homePageFontColor: config?.homePageFontColor || '',
      corDadosUsuario: config?.corDadosUsuario || '',
      assessoriaImage: config?.assessoriaImage || '',
      assessoriaLogo: config?.assessoriaLogo || '',
      urlLogoSecundario: config?.urlLogoSecundario || '',
      imagemCentralHome: config?.imagemCentralHome || '',
      imagemCentralMobile: config?.imagemCentralMobile || '',
      assessoriaName: config?.assessoriaName || '',
      termosUso: config?.useTerms || '',
      assessoriaTelephone: config?.assessoriaTelephone || '',
      enderecoAssessoria: config?.enderecoAssessoria || '',
      startBusinessDayAttendance: config?.startBusinessDayAttendance || '',
      endBusinessDayAttendance: config?.endBusinessDayAttendance || '',
      startSaturdayAttendance: config?.startSaturdayAttendance || '',
      endSaturdayAttendance: config?.endSaturdayAttendance || '',
      usaPix: config?.usaPix || '',
      usaPagamentoCartaoCredito: config?.usaPagamentoCartaoCredito || '',
      usaCopiarLD: config?.usaCopiarLD || '',
      usaSMSLD: config?.usaSMSLD || '',
      usaWhatsappLD: config?.usaWhatsappLD || '',
      usaEmailLD: config?.usaEmailLD || '',
      usaDownloadBoleto: config?.usaDownloadBoleto || '',
      usaImprimirBoleto: config?.usaImprimirBoleto || '',
      mensagemBoleto: config?.mensagemBoleto || '',
      usaReceberLigacao: config?.usaReceberLigacao || '',
      usaAgendarLigacao: config?.usaAgendarLigacao || '',
      usaLigarAgora: config?.usaLigarAgora || '',
      usaWhatsapp: config?.usaWhatsapp || '',
      usaEnviarMensagem: config?.usaEnviarMensagem || '',
      usaEnviarEmail: config?.usaEnviarEmail || '',
      usarDataNascimento: config?.usaDataNascimento || '',
      useTerms: config?.useTerms || '',
      politicaPrivacidade: config?.politicaPrivacidade || '',
      profileOmni: config?.profileOmni || '',
      tempoExpiracaoToken: config?.tempoExpiracaoToken || '',
      tituloSite: config?.tituloSite || '',
      whatsappContact: config?.whatsappContact || '',
      whatsappMessage: config?.whatsappMessage || '',
      enviaTokenSMS: config?.enviaTokenSMS || '',
      enviaTokenWhatsapp: config?.enviaTokenWhatsapp || '',
      validacaoAcesso: config?.validacaoAcesso || '',
      favicon: config?.favicon || '',
      gTagManager: config?.gTagManager || '',
      usaBordaHomePageCpfInput: config?.usaBordaHomePageCpfInput || '',
      exibeFaq: config?.exibeFaq || '',
      textoFaq: config?.textoFaq || '',
      mensagemCpfNaoEncontrado: config?.mensagemCpfNaoEncontrado || '',
      radiusButton: config?.radiusButton || '',
      nomeFont: config?.nomeFont || '',
      linkFont: config?.linkFont || '',
      corFontFooter: config?.corFontFooter || '',
      radiusCards: config?.radiusCards || '',
      radiusBotoesContato: config?.radiusBotoesContato || '',
      textoMelhorOpcao: config?.textoMelhorOpcao || '',
      emailAssessoria: config?.emailAssessoria || '',
    };
  };

  validateUser = async (
    hashId: string,
    campaignId: string
  ): Promise<ConfigUser> => {
    try {
      const result = await this.instance.post(
        'graphql',
        this.queries.validateUser({ hashId, campaignId })
      );
      const validate = (result.data.data as GQL.IQuery).validateUser;
      const databaseId = parseInt(hashId.slice(-2), 16);
      return {
        userCPF: validate.userCPF,
        userId: validate.userId,
        hasToken: validate.hasToken,
        userPJ: validate.userPJ,
        userName: validate.userName,
        creditorId: validate.creditorId,
        databaseId,
      };
    } catch (err) {
      return err as any;
    }
  };

  validateToken = async ({
    cpf,
    token,
    contactId,
    contactType,
    databaseId,
    tipoAcesso,
    creditorId,
  }: ValidationRequestDto): Promise<ValidationResponseDto> => {
    try {
      const result = await this.instance.post<
        ValidationResponseDto | ValidationResponseError
      >('auth/validateToken', {
        cpf: `${cpf}`,
        token: `${token}`,
        contactType: contactType.toLowerCase(),
        databaseId,
        contactId,
        tipoAcesso: tipoAcesso || 0,
        creditorId,
      });

      return result.data as ValidationResponseDto;
    } catch (error) {
      throw new Error(
        ((error as any).response.data as ValidationResponseError).message
      );
    }
  };

  getContacts = async (cpf: string): Promise<Array<UserContact>> => {
    const result = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getContacts({ cpf })
    );

    if (result.data.errors?.length) {
      throw new Error(result.data.errors[0].message);
    }

    const phones: Array<UserContact> =
      (result.data.data as GQL.IQuery).getTelephoneByCpf || [];
    const emails: Array<UserContact> =
      (result.data.data as GQL.IQuery).getEmail || [];

    if (phones.length === 0 && emails.length === 0) {
      const analytic = ((store.getState() as unknown) as ApplicationState)
        .analytic;
      store.dispatch(
        setErrorAnalytics.request({
          options: {
            actionId: analytic.navigation?.id ?? 0,
            errorMessage: 'Tentativa de login sem dados de contato na base',
            srcId: analytic.logRequestID ?? 0,
          },
        })
      );
    }

    return [...phones, ...emails];
  };

  getTelsAndEmails = async (cpf: string): Promise<Array<UserContact[]>> => {
    const result = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getContacts({ cpf })
    );

    if (result.data.errors?.length) {
      throw new Error(result.data.errors[0].message);
    }

    const phones: Array<UserContact> =
      (result.data.data as GQL.IQuery).getTelephoneByCpf || [];
    const emails: Array<UserContact> =
      (result.data.data as GQL.IQuery).getEmail || [];

    if (phones.length === 0 && emails.length === 0) {
      const analytic = ((store.getState() as unknown) as ApplicationState)
        .analytic;
      store.dispatch(
        setErrorAnalytics.request({
          options: {
            actionId: analytic.navigation?.id ?? 0,
            errorMessage: 'Tentativa de login sem dados de contato na base',
            srcId: analytic.logRequestID ?? 0,
          },
        })
      );
    }

    return [phones, emails];
  };

  setEmailConfirmado = async (data: GQL.ISetEmailConfirmado): Promise<any> => {
    const result = await this.instance.post(
      'graphql',
      this.queries.setEmailConfirmado(data)
    );

    if (result.data.errors?.length) {
      throw new Error(result.data.errors[0].message);
    }

    return result;
  };

  setTelefoneConfirmado = async (
    data: GQL.ISetTelefoneConfirmado
  ): Promise<any> => {
    const result = await this.instance.post(
      'graphql',
      this.queries.setTelefoneConfirmado(data)
    );

    if (result.data.errors?.length) {
      throw new Error(result.data.errors[0].message);
    }

    return 'ok';
  };

  setEnderecoConfirmado = async (
    data: GQL.ISetEnderecoConfirmado
  ): Promise<any> => {
    const result = await this.instance.post(
      'graphql',
      this.queries.setEnderecoConfirmado(data)
    );

    if (result.data.errors?.length) {
      throw new Error(result.data.errors[0].message);
    }

    return 'ok';
  };

  getPoliticaPrivacidadeDataAceite = async (): Promise<any> => {
    const result = await this.instance.post(
      'graphql',
      this.queries.getPoliticaPrivacidadeDataAceite()
    );

    if (result.data.errors?.length) {
      throw new Error(result.data.errors[0].message);
    }

    return result.data;
  };

  setPoliticaPrivacidadeDataAceite = async (): Promise<any> => {
    const result = await this.instance.post(
      'graphql',
      this.queries.setPoliticaPrivacidadeDataAceite()
    );

    if (result.data.errors?.length) {
      throw new Error(result.data.errors[0].message);
    }

    return result;
  };

  generateToken = async (
    payload: GQL.IGenerateTokenOnMutationArguments
  ): Promise<string> => {
    const result = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.generateToken(payload)
    );

    if (result.data.errors?.length) {
      throw new Error(result.data.errors[0].message);
    }

    return 'ok';
  };

  acceptTerms = async (): Promise<void> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.acceptTerms()
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
  };

  setToken = (token: string) =>
    (this.instance.defaults.headers.Authorization = `Bearer ${token}`);

  getUpdateDebts = async (): Promise<Array<GQL.IDebt>> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getUpdateDebts()
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getUpdatedDebts || [];
  };

  claimPayment = async (
    options: GQL.IClaimPaymentOnMutationArguments
  ): Promise<any> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.claimPayment(options)
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IMutation).claimPayment || [];
  };

  getProposalDetails = async ({
    creditorId,
    proposalType,
    proposalId,
  }: GQL.IGetProposalDetailsOnQueryArguments): Promise<
    Array<GQL.IProposalDetails>
  > => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getProposalDetails({
        creditorId,
        proposalType,
        proposalId,
      })
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getProposalDetails || [];
  };

  getAgreementDetails = async (): Promise<Array<GQL.IDeal>> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getAgreementDetails()
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getDealDebt || [];
  };

  sendEmail = async (data: SendEmail): Promise<string> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.sendEmail({ ...data })
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IMutation).sendEmail || '';
  };

  getUserNameByCpf = async (cpf: string): Promise<any> => {
    const result = await this.instance.post(
      'graphql',
      this.queries.getUserNameByCpf(cpf)
    );

    if (result.data.errors?.length) {
      throw new Error(result.data.errors[0].message);
    }

    return result.data.data.getUserNameByCpf;
  };

  getUserConfirmedData = async (): Promise<GQL.IUserResponse> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getUserConfirmedData()
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (
      (response.data.data as GQL.IQuery).getUserConfirmedData ||
      ({
        telephone: '',
        cep: '',
        city: '',
        complement: '',
        cpf: '',
        email: '',
        neighborhood: '',
        number: '',
        publicPlace: '',
        state: '',
        ddd_tel: '',
        addressType: null,
      } as GQL.IUserResponse)
    );
  };

  setUserConfirmedData = async (data: GQL.IUserInput): Promise<string> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.setUserConfirmedData(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return 'ok';
  };

  getAgreementPortionDetails = async ({
    dealId,
    databaseId,
  }: GQL.IGetDealPortionsOnQueryArguments): Promise<Array<GQL.IPortion>> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getAgreementPortionDetails({ dealId, databaseId })
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getDealPortions || [];
  };

  getBilletProposal = async ({
    planId,
    proposalId,
    databaseId,
  }: GQL.IGetBilletProposalOnQueryArguments): Promise<String> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getBilletProposal({ planId, proposalId, databaseId })
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getBilletProposal || '';
  };

  getBilletDeal = async ({
    dealId,
    portionId,
    databaseId,
  }: GQL.IGetBilletDealOnQueryArguments): Promise<GQL.IBillet> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getBilletDeal({ dealId, portionId, databaseId })
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (
      (response.data.data as GQL.IQuery).getBilletDeal || ({} as GQL.IBillet)
    );
  };

  getLinhaDigitavelProposalBillet = async (
    options: GQL.IGetLinhaDigitavelBilletOnQueryArguments
  ): Promise<GQL.IBillet> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getLinhaDigitavelProposalBillet(options)
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getLinhaDigitavelBillet;
  };

  getLinhaDigitavelDealBillet = async (
    options: GQL.IGetLinhaDigitavelDealOnQueryArguments & { databaseId: number }
  ): Promise<GQL.IBillet> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getLinhaDigitavelDealBillet(options)
    );

    if (response.data.errors?.length) {
      throw new Error(response.data.errors[0].message);
    }

    return (response.data.data as GQL.IQuery).getLinhaDigitavelDeal;
  };

  generateNewTelephone = async (
    data: GQL.IGenerateTokenInput,
    telephone: string
  ): Promise<string> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.generateNewTelephone(data, telephone)
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return 'ok';
  };

  validateNewTelephone = async (
    data: ValidateNewTelephone
  ): Promise<string> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.validateNewTelephone(data)
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return 'ok';
  };

  getNegotiationDetail = async (
    data: GQL.IGetDealOptionsOnQueryArguments
  ): Promise<Array<GQL.IOption>> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getNegotiationDetail(data)
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getDealOptions || [];
  };

  confirmNegotiation = async (
    data: GQL.IConfirmNegotiationOnQueryArguments
  ): Promise<GQL.IConfirmationInfo | null> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.confirmNegotiation(data)
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).confirmNegotiation;
  };

  getDebtDetails = async (
    data: GQL.IGetDebtDetailsOnQueryArguments
  ): Promise<GQL.IDebtDetailInfo | null> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getDebtDetails(data)
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);

    return (response.data.data as GQL.IQuery).getDebtDetails;
  };

  getDealState = async (
    data: GQL.IGetDealStateOnQueryArguments
  ): Promise<Array<GQL.IState>> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getDealState(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getDealState || [];
  };

  getWppByCreditorId = async (
    data: GQL.IGetPublicDataByCreditorIdOnQueryArguments
  ): Promise<GQL.ICreditorConfigPublicResponse | null> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getWppByCreditorId(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getPublicDataByCreditorId;
  };

  getDataConfirmationIsRequired = async (
    data: GQL.IGetPublicDataByCreditorIdOnQueryArguments
  ): Promise<GQL.ICreditorConfigPublicResponse | null> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getIfRegisterIsAllowed(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getPublicDataByCreditorId;
  };

  getIfRegisterIsAllowed = async (
    data: GQL.IGetPublicDataByCreditorIdOnQueryArguments
  ): Promise<GQL.ICreditorConfigPublicResponse | null> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getConfirmatedInfoIsRequired(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).getPublicDataByCreditorId;
  };

  setDeal = async (
    data: GQL.ISetDealOnQueryArguments
  ): Promise<Array<GQL.IState>> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.setDeal(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response.data.data as GQL.IQuery).setDeal || ({} as any);
  };

  setCall = async (
    data: Omit<GQL.ISetCallOnMutationArguments['options'], 'campanha'>,
    cpf: string
  ): Promise<void> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.setCall({
        cpf,
        options: { ...data, campanha: 'AutoNegociador' },
      })
    );
    if (response.data.errors?.length) {
      throw new Error(response.data.errors[0].message);
    }
    if ((response.data.data as GQL.IMutation).setCall === 'falha') {
      throw new Error('Ocorreu um erro no agendamento.');
    }
  };
  getBillet = async (
    data: GQL.IGetBilletOnQueryArguments
  ): Promise<GQL.IGetBilletPublicResponse> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getBillet(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response?.data.data as GQL.IQuery).getBillet || ({} as any);
  };
  rpaGetLinhaDigBillet = async (
    data: GQL.IGetBilletOnQueryArguments
  ): Promise<GQL.IGetBilletPublicResponse> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.rpaGetLinhaDigBillet(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (
      (response?.data.data as GQL.IQuery).rpaGetLinhaDigBillet || ({} as any)
    );
  };

  rpaGetMaskedCpf = async (
    data: GQL.IGetBilletOnQueryArguments
  ): Promise<string | null> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.rpaGetMaskedCpf(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response?.data.data as GQL.IQuery).getMaskedCpf;
  };

  rpaIsValidCpf = async (
    data: GQL.IGetValidCpfOnQueryArguments
  ): Promise<boolean | null> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.rpaIsValidCpf(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response?.data.data as GQL.IQuery).cpfIsValid;
  };

  getPixData = async (
    data: GQL.IGetPixDataOnQueryArguments
  ): Promise<GQL.IGetPixDataPublicResponse> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getPixData(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response?.data.data as GQL.IQuery).getPixData || ({} as any);
  };

  getIframePayment = async (
    data: GQL.IGetIframePaymentOnQueryArguments
  ): Promise<GQL.IGetIframePaymentPublicResponse> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getIframePayment(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response?.data.data as GQL.IQuery).getIframePayment || ({} as any);
  };

  getTermDeal = async (
    data: GQL.IGetTermDealOnQueryArguments
  ): Promise<string | null> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getTermDeal(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response?.data?.data as GQL.IQuery)?.getTermDeal || null;
  };

  sendIframeLog = async (
    data: GQL.ISendIframeLogOnMutationArguments
  ): Promise<GQL.ISendIframeLogPublicResponse> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.sendIframeLog(data)
    );

    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response?.data.data as GQL.IMutation).sendIframeLog || ({} as any);
  };

  rpaGetListBilletByCpf = async (
    data: GQL.IGetListBilletByCpf
  ): Promise<GQL.ListBilletResponse[]> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.rpaGetListBilletByCpf(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (
      (response?.data.data as GQL.IQuery).rpaGetListBilletByCpf || ({} as any)
    );
  };

  getPosNegotiationMessage = async (
    data: GQL.IGetPublicDataByCreditorIdOnQueryArguments
  ): Promise<GQL.ICreditorConfigPublicResponse> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.getPosNegotiationMessage(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response?.data.data as GQL.IQuery).getPublicDataByCreditorId;
  };

  validateCreditCard = async (
    data: GQL.IValidateCreditCardOnMutationArguments
  ): Promise<GQL.IValidateCreditCardResponse> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.validateCreditCard(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return (response?.data.data as GQL.IQuery).validateCreditCard;
  };

  deleteDeal = async (
    data: GQL.IDeleteDealOnMutationArguments
  ): Promise<any> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.deleteDeal(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return response?.data.data as GQL.IQuery;
  };

  confirmCreditCardPayment = async (
    data: GQL.IConfirmCreditCardPaymentOnMutationArguments
  ): Promise<any> => {
    const response = await this.instance.post<GQL.IGraphQLResponseRoot>(
      'graphql',
      this.queries.confirmCreditCardPayment(data)
    );
    if (response.data.errors?.length)
      throw new Error(response.data.errors[0].message);
    return response?.data.data as GQL.IQuery;
  };
}

export default new ConfigThemeService();
